import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./sections/HeroSection";
import AboutSection from "./sections/AboutSection";
import StatsSection from "./sections/StatsSection";
import TechnologySection from "./sections/TechnologySection";
import SolutionsSection from "./sections/SolutionsSection";
import NewsSection from "./sections/NewsSection";
import ContactSection from "./sections/ContactSection";
import JsonLd from "../../components/base/JsonLd";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "에너버즈(EnerVerze) - AI Energy Platform | 스마트그리드·디지털트윈 에너지 플랫폼",
  "description": "에너버즈(EnerVerze)는 AI와 에너지 플랫폼을 융합한 AI Energy Platform 기업입니다. 스마트그리드, 디지털트윈, 분산에너지 네트워크, 수소에너지, 태양광·태양열 등 미래 에너지 솔루션을 제공합니다.",
  "url": "https://enerverze.com/",
  "inLanguage": "ko-KR",
  "isPartOf": {
    "@type": "WebSite",
    "name": "에너버즈(EnerVerze)",
    "url": "https://enerverze.com/"
  },
  "about": {
    "@type": "Organization",
    "name": "에너버즈",
    "alternateName": "EnerVerze",
    "url": "https://enerverze.com/",
    "description": "AI 기반 에너지 플랫폼, 스마트그리드, 디지털트윈, 분산에너지 네트워크 솔루션을 제공하는 에너지 전문 기업",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "KR",
      "addressRegion": "경기도",
      "addressLocality": "파주시",
      "streetAddress": "문발로 132"
    }
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-enerverze-bg">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <StatsSection />
        <TechnologySection />
        <SolutionsSection />
        <NewsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}